export const fixMojibake = (text) => {
  try {
    const bytes = Uint8Array.from(
      Array.from(text, c => c.charCodeAt(0))
    );
    return new TextDecoder("utf-8").decode(bytes);
  } catch {
    return text;
  }
}
